import { Globe } from '@styled-icons/bootstrap/Globe';
import { Lock } from '@styled-icons/fa-solid/Lock';
import React from 'react';
import {
  EDocumentVisibilityStatus,
  TDocumentVisibilityStatus,
} from 'FeatureModules/Document/types/document.types';
import { DocumentVisibilityLabels } from 'FeatureModules/Document/utils/document.utils';

export type TVisibilityStatusKeyValue = {
  key: TDocumentVisibilityStatus;
  value: string;
  icon: JSX.Element;
};

export const getVisibilityIcon = (
  visibility: TDocumentVisibilityStatus,
  size: number = 14
): JSX.Element => {
  if (visibility === EDocumentVisibilityStatus.PUBLIC) {
    return <Globe size={size} />;
  }

  return <Lock size={size} />;
};

const documentVisibilityOptions: TVisibilityStatusKeyValue[] = [
  EDocumentVisibilityStatus.PRIVATE,
  EDocumentVisibilityStatus.PUBLIC,
].map(key => ({
  key: key,
  value: DocumentVisibilityLabels[key],
  icon: getVisibilityIcon(key),
}));

export default documentVisibilityOptions;
